// Central company info constants — single source of truth.
// Sourced from Companies House record 15033092.

export const COMPANY = {
    legalName: "ElevateBuild Construction Services Ltd",
    displayName: "EB Construction",
    tagline: "Built on Trust. Designed for Life.",
    // Historical marketing sub-headline (retained for backward compat).
    subTagline: "Construction Services",
    companyNumber: "15033092",
    jurisdiction: "England & Wales",
    // Founded date (client-confirmed)
    founded: "2023-10-23",
    foundedDisplay: "23 October 2023",
    // Kept for backward compat with existing components that read these
    incorporatedYear: 2023,
    incorporatedDate: "23 October 2023",
    address: {
        // Structured for JSON-LD PostalAddress
        streetAddress: "82 King Street",
        line1: "82 King Street",
        line2: null,
        city: "Manchester",
        region: "Greater Manchester",
        postcode: "M2 4WQ",
        country: "GB",
        countryName: "United Kingdom",
        // Convenience formatted strings
        oneLine: "82 King Street, Manchester M2 4WQ",
        multiLine: "82 King Street\nManchester M2 4WQ",
    },
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=82+King+Street+Manchester+M2+4WQ",
    // Client-confirmed contact number (Feb 2026 update).
    phone: "+44 7947 928090",
    phoneDisplay: "+44 7947 928090",
    phoneE164: "+447947928090",
    phoneHref: "tel:+447947928090",
    // Primary ops mailbox (client-confirmed).
    email: "admin@elevatebuildconstruction.co.uk",
    emailHref: "mailto:admin@elevatebuildconstruction.co.uk",
    hours: "Mon–Fri · 08:00 – 18:00",
    // Home Office licensed sponsor (Worker & Temporary Worker routes)
    licensedSponsor: true,
    sponsorRoutes: "Skilled Worker route",
    // Registered legal line for footer / legal pages
    legalLine:
        "ElevateBuild Construction Services Ltd · Founded 23 October 2023 · Registered in England & Wales · Company No. 15033092",
    // Site-wide notices. Set `enabled: false` on a notice to hide it without
    // a code change. Bump `version` (and update the localStorage suffix) to
    // re-broadcast a previously-dismissed notice.
    NOTICES: {
        domainMigration: {
            version: 1,
            enabled: true,
            oldDomain: "ebconstructionservices.co.uk",
            newDomain: "elevatebuild",
            storageKey: "elevatebuild_notice_domain_migration_v1",
        },
    },
};

/**
 * Ordered list of notices shown in the auto-rotating banner slider at the
 * top of every public page. Editing this list is the ONLY place to change
 * broadcast copy — every other component reads from here.
 *
 * Rotate cadence, pause-on-hover, chevrons/dots and dismiss persistence are
 * all handled in `SiteNotice.jsx`.
 *
 * Bump `SITE_NOTICE_STORAGE_KEY` when you want previously-dismissed users
 * to see the banner again (e.g. after a material re-broadcast).
 */
export const SITE_NOTICE_STORAGE_KEY = "elevatebuild_notice_v2";

export const SITE_NOTICES = [
    {
        id: "domain-migration-v2",
        label: "Important Notice",
        heading: "Official Website Update",
        text: "Our previous website, ebconstructionservices.co.uk, has been retired. You are now visiting the official website of EB Construction Ltd.",
    },
];

export default COMPANY;
